import { HandThumbUpIcon } from "@heroicons/react/24/outline";
import {generate} from "../../../routing/routes";
import hikingImage from "../../../theme/img/bg/marcheurs2.jpeg";

export default function NewTrip({maxDraftCount}) {
    return (
        <div
            className="
                overflow-hidden rounded-xl border border-gray-200 shadow-md
                lg:flex lg:flex-row-reverse
            "
        >
            <div className="hidden pl-8 lg:block lg:w-2/3">
                <div
                    className={"h-full w-full rounded-lg bg-cover bg-center lg:rounded-none"}
                    style={{
                        backgroundImage: `url(${hikingImage})`,
                    }}
                ></div>
            </div>
            <div
                className={
                    "flex items-center p-8 text-center lg:w-1/3 lg:px-12 lg:py-8 lg:text-left"
                }
            >
                <div className="mx-auto lg:mx-0">
                    <HandThumbUpIcon className="mx-auto mb-6 h-10 w-10 text-orange-500 lg:mx-0" />
                    <h2 className="font-medium text-gray-800">
                        Aucune réservation... Pour l'instant !
                    </h2>
                    {maxDraftCount ? <p className="mb-6 text-sm text-gray-600 my-5">
                        Vous avez atteint le nombre maximum de brouillons, validez ou supprimez l'un d'eux.
                    </p> : <><p className="mb-6 text-sm text-gray-600">
                        Créez votre premier voyage en quelques clics.
                    </p>
                    <a
                        href={generate('book')}
                        type="button"
                        className="inline-flex items-center rounded-md border border-transparent bg-orange-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
                    >
                        Créer un nouveau voyage
                    </a>
                    </>}
                </div>
            </div>
        </div>
    );
}
